import { atom } from 'recoil';
import BeaconFilterVariant from '../models/BeaconFilterVariant';

const stateFilterVariant = atom({
  key: 'filter.variant',
  default: null as BeaconFilterVariant | null,
});

export default stateFilterVariant;
